import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../common/components/table";
import PageLoader from "../../../../../components/PageLoader";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectLogsListItems } from "../../../../../redux/logs/selector";
import { logs } from "../../../../../redux/logs/action";


const ManagementLogs = () => {
	const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)

    const itemsData = useSelector(selectLogsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'FirstName', headerName: 'First Name' },
          { field: 'LastName', headerName: 'Last Name' },
          { field: 'Email', headerName: 'Email' },
          { field: 'LastIpAddress', headerName: 'Last IpAddress' },
          { field: 'LastLoginUtc', headerName: 'Last Login', isDateValueFormat:true }
      
        ]);
      }
     
      const fetchLogs=()=>{
        dispatch(logs.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/logs`,entity:'logs',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
	useEffect(() => {
        createColumnDefs()
        fetchLogs()
	}, [pageData])

	return (
    <>
    {itemsData?.isLoading ? <PageLoader />
 : 
		<Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData}
    paginationData={itemsData?.result?.pagination}  headingName="Logs"/>
     
  }
  </>
	);
};

export default ManagementLogs;


